module.exports = __webpack_public_path__ + "fonts/ralewayregular.bd114be.ttf";